import http from '../../../Http';
import { ThemeContext } from '../../../Http';
import { useState, useContext, useRef, useEffect } from 'react';
import utils from '../../../utils';
import { DatePicker , Input, Button, Form, Row, Col, Select,Collapse} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import WS from "../WS";
import CRC from './ModbusCRC';
import moment from 'moment';
import BitsEditor from './BitsEditor';
import HourMinuteEditorForSungery from './HourMinuteEditorForSungery';
import { useTranslation } from 'react-i18next';

const HMAddresses = [0xA0A1,0xA0A2,0xA0A3,0xA0A4,0xA0A5,0xA0A6,0xA0A8,0xA0A9,0xA0Aa,0xA0Ab,0xA0Ac,0xA0Ad];

function SungerySetting({SN, SettingDefs}) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language === "en" ? "English" : "Chinese";
    
    const setTip = useContext(utils.tipContext);
    const session = useContext(ThemeContext);
   
    const [online, setOnline] = useState(false);
    const [pendingValues, setPendingValues] = useState({});
    const [doingsResult, setDoingsResult] = useState({});
    const [writeErrors, setWriteErrors] = useState({});
    const [turnOn, setTurnOn] = useState(null)
    
    const refComfirmedValues = useRef({});
    const refPendingValues = useRef({});
    const refPendingCmds = useRef([]);
    const refExecutingCmd = useRef(null); 


    const [form] = Form.useForm();

    const defMap = {};
    const defs = [];
    var subDefs = [];
    var lastCategory = null;
    var vs = {}
    if (SettingDefs != null) { 
        if (SettingDefs.some(o=>o.RegisterAddressNumber==0xf400) == false) {
            SettingDefs.push({
                "Category": "DTU",
                "CreateTime": null,
                "Enums": "1: Socket On; 254: CT On; 0: Socket Close; 255: Offline",
                "Format": null,
                "Intls": {"English":"WiFi Socket\\CT","Chinese":"WiFi插座\\CT"},
                "Intls2": {
                    "Sungery#Setting#62464:Socket On-English":"Socket On",
                    "Sungery#Setting#62464:Socket On-Chinese":"插座开启",
                    "Sungery#Setting#62464:CT On-English":"CT On",
                    "Sungery#Setting#62464:CT On-Chinese":"CT开启",
                    "Sungery#Setting#62464:Socket Close-English":"Socket Close",
                    "Sungery#Setting#62464:Socket Close-Chinese":"插座关闭",
                    "Sungery#Setting#62464:Offline-English":"Offline",
                    "Sungery#Setting#62464:Offline-Chinese":"离线"
                },
                "MultiValue": null,
                "Pending": null,
                "Ranges": "[0,255]",
                "ReadWrite": "RW",
                "RegisterAddress": "F400",
                "RegisterAddressNumber": 62464,
                "RegisterNumber": 1,
                "RegisterType": "U16",
                "Remark": "$Intl:Sungery#Setting#62464",
                "Scale": 1,
                "Unit": "",
                "Value": null
            })
        } 
        if (SettingDefs.some(o=>o.RegisterAddressNumber==0xf053) == false) {
            SettingDefs.push({
                "Category": "DTU",
                "CreateTime": null,
                "Enums": "0: Three-phase Separate; 1: During Parallel Operation, Three-phase Accumulation",
                "Format": null,
                "Intls": {"English":"WiFi CT Work Mode","Chinese":"无线电表工作模式"},
                "Intls2": {
                    "Sungery#Setting#61523:Three-phase Separate-English":"Three-phase Separate",
                    "Sungery#Setting#61523:Three-phase Separate-Chinese":"三相分开（非并机）",
                    "Sungery#Setting#61523:During Parallel Operation, Three-phase Accumulation-English":"During Parallel Operation, Three-phase Accumulation",
                    "Sungery#Setting#61523:During Parallel Operation, Three-phase Accumulation-Chinese":"并机时三相功率相加"
                },
                "MultiValue": null,
                "Pending": null,
                "Ranges": "[0,255]",
                "ReadWrite": "RW",
                "RegisterAddress": "F053",
                "RegisterAddressNumber": 61523,
                "RegisterNumber": 1,
                "RegisterType": "U16",
                "Remark": "$Intl:Sungery#Setting#61523",
                "Scale": 1,
                "Unit": "",
                "Value": null
            })
        }
    }
    for (var k in SettingDefs) {
        var def = SettingDefs[k];
        var address = def.RegisterAddressNumber;
        defMap[address] = def;
        if (lastCategory != def.Category) {
            subDefs = [];
            defs.push(subDefs);
            lastCategory = def.Category;
        }
        subDefs.push(def);
        //
        vs[address] = def.Value;
        if (def.Scale && def.Value != null && def.Scale<1 && !isNaN(def.Value)) {
            vs[address] = def.Value * def.Scale;
            vs[address] = vs[address].toFixed(def.Scale.toString().length-2 > 0 ? def.Scale.toString().length-2 : 0);
        }
    }
    if (Object.keys(vs).length != Object.keys(refComfirmedValues.current).length) {
        refComfirmedValues.current = {...vs};
        setTimeout(()=>setFormFieldsValue(vs), 50);
    }
    //2024.7.8
    for (var i in defs) {
        var sds = defs[i];
        if (sds.length < 1 || sds[0].Category != "Setting-Param") {
            continue;
        }

        var da043 = null; //并网标准设置
        var da028 = null; //负载供电优先级 即 Work Mode
        var da088 = null; //防逆流馈网使能 即 FeedInEn
        var da02e = null; //充电优先级设置
        var da034 = null; //能量上网设置
        for (var j = sds.length-1; j>=0; j--) {
            var sd = sds[j];
            if (sd.RegisterAddressNumber == 0xa043) {
                da043 = sd;
                sds.splice(j, 1);
            } else if (sd.RegisterAddressNumber == 0xa028) {
                da028 = sd;
                sds.splice(j, 1);
            } else if (sd.RegisterAddressNumber == 0xa088) {
                da088 = sd;
                sds.splice(j, 1);
            } else if (sd.RegisterAddressNumber == 0xa02e) {
                da02e = sd;
                sds.splice(j, 1);
            } else if (sd.RegisterAddressNumber == 0xa034) {
                da034 = sd;
                sds.splice(j, 1);
            }
        }
        sds.splice(0, 0, da043, da028, da088, da02e, da034);
    }

    const [FirmwareVersion, setFirmwareVersion] = useState('')  //DTU Firmware Version
    const isParallelVersion = FirmwareVersion && FirmwareVersion.startsWith('I03')
    //console.log('isParallelVersion', isParallelVersion)

    useEffect(() => {
        if (!SN) {
            return;
        }
        let active = true;

        (async () => {
            let resp = await http.post("integrated-inverter/dtu-firmware-version/get", { SerialNumber: SN }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setFirmwareVersion('')
                return;
            }

            setFirmwareVersion(resp.data)
        })();

        return () => {
            active = false;
        };
    }, [SN])

    useEffect(() => {
        refComfirmedValues.current = {...vs};
        refPendingValues.current = {};
        setFormFieldsValue(vs)
        setPendingValues({});
    }, [SN, SettingDefs]);

    const hex2Array = (hex) => {
        var arr = new Uint8Array(hex.match(/[\da-f]{2}/gi).map((h)=>parseInt(h, 16)));
        return Array.prototype.slice.call(new Uint8Array(arr.buffer )); 
    }

    const Array2hex = (arr) => {
        return arr.map((v) => v.toString(16).padStart(2, "0")).join("");
    }

    const setFormFieldsValue = (vs) => {
        vs = {...vs};
        for (var k in vs) {
            var v = vs[k]
            if (defMap[k].RegisterAddressNumber == 0xa03a) {
                const dt = `${((vs[0xa03a]>>8)&0xff)+2000}-${vs[0xa03a]&0xff}-${(vs[0xa03b]>>8)&0xff} ${vs[0xa03b]&0xff}:${(vs[0xa03c]>>8)&0xff}:${vs[0xa03c]&0xff}`;
                vs[k] = moment(dt, "YYYY-MM-DD HH:mm:ss");
                if (v == null) {
                    vs[k] = null;
                }
            }
        }
        //form.setFieldsValue(vs)
        Object.keys(refPendingValues.current).length == 0 && form.setFieldsValue(vs)   //2024-5-31
    }

    const handleWSConnect = () => {
        setOnline(true);
    }

    const handleWSData = (data) => {
        if (!data || data.InverterSN != SN) {
            return;
        }  
        if (data.SessionID == 0) return;

        var resp = hex2Array(data.Response);

        let cmd = null;
        let cmds = refPendingCmds.current;
        for (var i in cmds) {
            if (cmds[i].SessionID == data.SessionID) {
                cmd = cmds[i];
                cmds.splice(i, 1);
                break
            }
        }
        if (refExecutingCmd.current != null && refExecutingCmd.current.SessionID== data.SessionID) {
            cmd = refExecutingCmd.current;
            refExecutingCmd.current = null;
        }
        if (!cmd) {
            return;
        }
        if (resp[1] != 0x03 && resp[1] != 0x06 && resp[1] != 0x10) {
            setTip({ open: true, severity: "info", msg: t("command(s) error!") });
            return;
        }
        if (cmd.Code == 0x03) {
            var address = cmd.Address;
            var count = cmd.Count;
            var vs = {};
            for (var i=0; i<count; i++) {
                var addr = address + i;
                var idx = i*2 + 3;
                if (defMap.hasOwnProperty(addr)) {
                    var def = defMap[addr];
                    switch (def.RegisterType) {
                        case "U16":
                            var v = (resp[idx]<<8) + resp[idx + 1];
                            vs[addr] = v;
                            break;
                        case "I16":
                            var v = (resp[idx]<<8) + resp[idx + 1];
                            if (v >0x7fff) {
                                v -= 0xffff + 1;
                            }
                            vs[addr] = v;
                            break;
                        case "U32":
                            var v = (resp[idx]<<24) + (resp[idx+1]<<16) + (resp[idx+2]<<8) + resp[idx + 3];
                            vs[addr] = v;
                            break;
                        case "I32":
                            var v = (resp[idx]<<24) + (resp[idx+1]<<16) + (resp[idx+2]<<8) + resp[idx + 3];
                            if (v >0x7fffffff) {
                                v -= 0xffffffff + 1;
                            }
                            vs[addr] = v;
                            break;
                    }
                    i += def.RegisterNumber - 1;
                }
            }
            if (Object.keys(vs).length > 0) {
                for (var k in vs) {
                    var def = defMap[k];
                    if (def.Scale && def.Scale<1) {
                        vs[k] *= def.Scale;
                        vs[k] = vs[k].toFixed(def.Scale.toString().length-2 > 0 ? def.Scale.toString().length-2 : 0);
                    }
                }

                var pvs = refPendingValues.current;
                var pvs_changed = false;
                for (var k in vs) {
                    if (pvs.hasOwnProperty(k)) {
                        pvs_changed = true;
                        delete pvs[k];
                    }
                }
                if (pvs_changed) {
                    setPendingValues({...pvs});
                }

                refComfirmedValues.current = {...refComfirmedValues.current, ...vs}
                setFormFieldsValue({...refComfirmedValues.current});

            }
        } else if (cmd.Code == 0x06) {
            var address = cmd.Address;
            if (resp[1] == 0x06) {
                var v = (resp[4]<<8) + resp[5];
                if (defMap.hasOwnProperty(address)) {
                    var def = defMap[address];
                    if (def.RegisterType == "I16") {
                        if (v >0x7fff) {
                            v -= 0xffff + 1;
                        }
                    }
                    if (def.Scale && def.Scale<1) {
                        v *= def.Scale;
                        v = v.toFixed(def.Scale.toString().length-2 > 0 ? def.Scale.toString().length-2 : 0);
                    }

                    var pvs = refPendingValues.current;
                    delete pvs[address];
                    setPendingValues({...pvs});

                    refComfirmedValues.current = {...refComfirmedValues.current, ...{[address]:v}}
                    setFormFieldsValue(refComfirmedValues.current);


                    // if ([0x3416,0x3417,0x341d,0x362a,0x362b,0x362c].indexOf(address) > -1) {
                    //     setTip({ open: true, severity: "success", msg: "command "+def.Intls["English"]+" success" });
                    // }
                }
                
            } 
        } else if (cmd.Code == 0x10) {
            var address = cmd.Address;
            if (resp[1] == 0x10) {//0xa03a~0xa03c
                var v = (resp[4]<<8) + resp[5];
                if (defMap.hasOwnProperty(address)) {
                    var def = defMap[address];
                   
                    var pvs = refPendingValues.current;

                    var pvs2 = {...pvs};
                    if (address == 0xa03a) {
                        delete pvs2[0xa03a];
                        delete pvs2[0xa03b];
                        delete pvs2[0xa03c];
                    } else {
                        delete pvs2[address];
                    }
                    setPendingValues({...pvs2});

                    if (address == 0xa03a) {
                        refComfirmedValues.current = {...refComfirmedValues.current, ...{
                            0xa03a:pvs[0xa03a],
                            0xa03b:pvs[0xa03b],
                            0xa03c:pvs[0xa03c],
                        }}
                    } else {
                        refComfirmedValues.current = {...refComfirmedValues.current, ...{[address]:v}}
                    }
                    setFormFieldsValue(refComfirmedValues.current);

                }
                
            } 
        }
    }

    const handleWSClose = () => {
        setOnline(false)
    }

    const handleWSError = () => {
        //
    }

    const handleReset = (Category) => {
        var vs = {};
        var pvs = refPendingValues.current;
        var cvs = refComfirmedValues.current;
        var had = false;
        for (var k in pvs) {
            var def = defMap[k];
            if ( defMap.hasOwnProperty(k) && def.Category == Category) {
                had = true;
                vs[k] = cvs[k];
                delete pvs[k];
            }
        } 
        if (had) {
            // form.setFieldsValue(vs);
            setFormFieldsValue(vs);
            setPendingValues({...pvs});
        }
    }

    //command dispatcher
    setInterval(async ()=>{
        let cmd = refExecutingCmd.current;
        let cmds = refPendingCmds.current;
        let dt = Date.now();
        if (cmd == null) {
            if (cmds.length < 1) {
                return;
            } 

            cmd = cmds[0];
            cmd.TimeoutStart = dt;
            cmds.splice(0,1);
            refExecutingCmd.current = cmd;
        }
        if (dt != cmd.TimeoutStart && dt-cmd.TimeoutStart < 5000) {
            return;
        }
        console.log("[Timeout]", cmd, cmd.TimeoutStart, dt, cmd.RetryCount);
        cmd.TimeoutStart = dt;
        let cmd2 = cmd.cmd2;

        if (cmd.RetryCount != undefined && cmd.RetryCount >= 2) {
            setTip({ open: true, severity: "error", msg: t("Command sending times exceed the limit or timeout") });
            refExecutingCmd.current = null;
            return;
        }

        //
        if (cmd.RetryCount == undefined) {
            cmd.RetryCount = 0;
        } else {
            cmd.RetryCount ++;
        }
        cmd2.DeviceCategory = 1;
        const resp = await http.postJSON("integrated-inverter/setting/request", cmd2).then(async (r) => {
            return await r.json();
        }).catch((e) => {
            console.log("[Setting]", e);
            return null;
        });
        console.log("[+++]", Date.now());
    }, 200)

    const postCmd = async (cmd1, cmd2) => {
        try {
            const resp2 = await http.postJSON("business-session/new-id/get", {
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[Setting]", e);
                return null;
            });
            const SessionID = resp2.data.SessionID % 0xffffffff;
            if (isNaN(SessionID) || SessionID == null) {
                setTip({ open: true, severity: "error", msg: t("Unable to get SessionID") });
                return;
            }
            cmd1["SessionID"] = SessionID;
            cmd2["SessionID"] = SessionID;

            cmd1.cmd2 = cmd2;
            refPendingCmds.current.push(cmd1);

        } catch (e) {
            console.log("[Setting]", e);
            setTip({ open: true, severity: "error", msg: t("Read-Write error") });
        }        
    }

    const handleRead = async (Category) => {
        var address = 0xffff;
        var addressTrack = address;
        var count = 0;
        
        if (Object.keys(refPendingCmds.current).length > 0 || refExecutingCmd.current != null) {
            setTip({ open: true, severity: "info", msg: t("waiting for pending command(s)...") });
            return;
        }

        for (var i in SettingDefs) {
            var def = SettingDefs[i];
            if (def.Category == Category) {
                if (address > def.RegisterAddressNumber) {
                    address = def.RegisterAddressNumber;
                    addressTrack = address;
                    count = 0;
                }
                if (
                    (def.RegisterAddressNumber != addressTrack && def.RegisterAddressNumber != addressTrack+1 && count > 0) || 
                    /*(def.ReadWrite.indexOf("R") == -1 && count > 40) ||*/ 
                    (def.ReadWrite.indexOf("R") == -1 && count > 0) ||
                    count >=40
                ) {
                    console.log("[Setting-Read]", address.toString(16), count);

                    const cmd1 = {
                        "Code": 0x03,
                        "Address": address,
                        "Count": count,
                    };
                    const cmd2 = {
                        SerialNumber: SN,
                        SettingRead: {
                            [(address).toString(16)]: cmd1.Count,
                        },
                    }
                    postCmd(cmd1, cmd2);
                    if (def.ReadWrite.indexOf("R") == -1) {
                        address = 0xffff;
                        count = 0;
                    } else {
                        address = def.RegisterAddressNumber;
                        addressTrack = address;
                        count = 1;
                    }
                } else if (def.ReadWrite.indexOf("R") == -1) {
                    address = 0xffff;
                    count = 0;
                } else {
                    addressTrack = def.RegisterAddressNumber;
                    count ++;
                }
            } else {
                if (address != 0xffff) {
                    break;
                }
            }
        }
        if (count > 0) {
            console.log("[Setting-Read]", address.toString(16), count);

            const cmd1 = {
                "Code": 0x03,
                "Address": address,
                "Count": count,
            };
            const cmd2 = {
                SerialNumber: SN,
                SettingRead: {
                    [(address).toString(16)]: cmd1.Count,
                },
            }
            postCmd(cmd1, cmd2);
        }
    }

    const handleWrite = async (Category) => {
        var pvs = refPendingValues.current;
        if (Object.keys(pvs).length <= 0) {
            return;
        } 

        if (Object.keys(refPendingCmds.current).length > 0 || refExecutingCmd.current != null) {
            setTip({ open: true, severity: "info", msg: t("waiting for pending command(s)...") });
            return;
        }

        setWriteErrors({});

        var cvs = refComfirmedValues.current;
        var ok = true;
        for (var i in SettingDefs) {
            var def = SettingDefs[i];
            var bs = [];
            const address = def.RegisterAddressNumber;
            if ([0xa03b,0xa03c].indexOf(address) > -1) {
                continue;
            }
            var v = pvs[address];
            if (def.Category == Category && v != undefined) {
                if (address == 0xa03a) { 
                    bs.push((v>>8) & 0xff, v & 0xff);
                    v = pvs[0xa03b];
                    bs.push((v>>8) & 0xff, v & 0xff);
                    v = pvs[0xa03c];
                    bs.push((v>>8) & 0xff, v & 0xff);

                    bs = [isParallelVersion ? 0xff : 0x01, 0x10, (address>>8)&0xff, address&0xff, 0,3,bs.length, ...bs];
                    var str = CRC.ToModbusCRC16(bs);
                    str = Array2hex(bs) + str;

                    const cmd1 = {
                        "Code": 0x10,
                        "Address": address,
                        "Request": str,
                    };
                    const cmd2 = {
                        SerialNumber: SN,
                        Setting: {
                            [address.toString(16)]: str,
                        },
                    }

                    postCmd(cmd1, cmd2);
                } else {
                    //v = parseInt(v)
                    v = parseFloat(v)
                    if (isNaN(v) || v === null) {
                        continue;
                    }

                    if (def.Scale) {
                        v /= def.Scale;
                        v = Math.round(v);
                    }

                    switch (def.RegisterType) {
                        case "U16":
                            bs.push((v>>8) & 0xff, v & 0xff);
                            break;
                        case "I16":
                            if (v < 0) {
                                v += 0xffff + 1;
                            }
                            bs.push((v>>8) & 0xff, v & 0xff);
                            break;
                        case "U32":
                            bs.push((v>>24) & 0xff, (v>>16) & 0xff, (v>>8) & 0xff, v & 0xff);
                            break;
                        case "I32":
                            if (v < 0) {
                                v += 0xffffffff + 1;
                            }
                            bs.push((v>>24) & 0xff, (v>>16) & 0xff, (v>>8) & 0xff, v & 0xff);
                            break;
                    }
                    bs = [isParallelVersion ? 0xff : 0x01, 0x06, (address>>8)&0xff, address&0xff, ...bs];
                    var str = CRC.ToModbusCRC16(bs);
                    str = Array2hex(bs) + str;

                    const cmd1 = {
                        "Code": 0x06,
                        "Address": address,
                        "Request": str,
                    };
                    const cmd2 = {
                        SerialNumber: SN,
                        Setting: {
                            [address.toString(16)]: str,
                        },
                    }
                    postCmd(cmd1, cmd2);
                }
            }
        }
    }

    const handleReadSingle = async (RegisterAddressNumber) => {
        if (Object.keys(refPendingCmds.current).length > 0 || refExecutingCmd.current != null) {
            setTip({ open: true, severity: "info", msg: t("waiting for pending command(s)...") });
            return;
        }

        console.log("[ReadSingle][RegisterAddressNumber]", RegisterAddressNumber.toString(16));
        const address = parseInt(RegisterAddressNumber);
        const cmd1 = {
            "Code": 0x03,
            "Address": address,
            "Count": address == 0xa03a ? 3 : 1,
        };
        const cmd2 = {
            SerialNumber: SN,
            SettingRead: {
                [(address).toString(16)]: cmd1.Count,
            },
        }
        postCmd(cmd1, cmd2);

        var addressTrack = address;
        var count = 1;
    }

    const handleWriteSingle = async (RegisterAddressNumber) => {
        var pvs = refPendingValues.current;
        if (Object.keys(pvs).length <= 0) {
            return;
        } 
        
        if (Object.keys(refPendingCmds.current).length > 0 || refExecutingCmd.current != null) {
            setTip({ open: true, severity: "info", msg: t("waiting for pending command(s)...") });
            return;
        }

        const address = parseInt(RegisterAddressNumber);
        var def = defMap[address];  //add
        var bs = [];
        var v = pvs[address];
        if (isNaN(v) || v === null) {
            return;
        }
        if (address == 0xa03a) { 
            bs.push((v>>8) & 0xff, v & 0xff);
            v = pvs[0xa03b];
            bs.push((v>>8) & 0xff, v & 0xff);
            v = pvs[0xa03c];
            bs.push((v>>8) & 0xff, v & 0xff);

            bs = [isParallelVersion ? 0xff : 0x01, 0x10, (address>>8)&0xff, address&0xff, 0,3,bs.length, ...bs];
            var str = CRC.ToModbusCRC16(bs);
            str = Array2hex(bs) + str;

            const cmd1 = {
                "Code": 0x10,
                "Address": address,
                "Request": str,
            };
            const cmd2 = {
                SerialNumber: SN,
                Setting: {
                    [address.toString(16)]: str,
                },
            }

            postCmd(cmd1, cmd2);
        } else if (address == 0xF400 || address == 0xF053) { // 2026.2.27
            bs = [0x01, 0x10, (address>>8)&0xff, address&0xff, 0,1,2, (v>>8) & 0xff, v & 0xff];
            var str = CRC.ToModbusCRC16(bs);
            str = Array2hex(bs) + str;

            const cmd1 = {
                "Code": 0x10,
                "Address": address,
                "Request": str,
            };
            const cmd2 = {
                SerialNumber: SN,
                Setting: {
                    [address.toString(16)]: str,
                },
            }

            postCmd(cmd1, cmd2);
        } else {
            //v = parseInt(v)
            v = parseFloat(v)

            if (def.Scale) {
                v /= def.Scale;
                v = Math.round(v);
            }

            switch (def.RegisterType) {
                case "U16":
                    bs.push((v>>8) & 0xff, v & 0xff);
                    break;
                case "I16":
                    if (v < 0) {
                        v += 0xffff + 1;
                    }
                    bs.push((v>>8) & 0xff, v & 0xff);
                    break;
                case "U32":
                    bs.push((v>>24) & 0xff, (v>>16) & 0xff, (v>>8) & 0xff, v & 0xff);
                    break;
                case "I32":
                    if (v < 0) {
                        v += 0xffffffff + 1;
                    }
                    bs.push((v>>24) & 0xff, (v>>16) & 0xff, (v>>8) & 0xff, v & 0xff);
                    break;
            }
            bs = [isParallelVersion ? 0xff : 0x01, 0x06, (address>>8)&0xff, address&0xff, ...bs];
            var str = CRC.ToModbusCRC16(bs);
            str = Array2hex(bs) + str;

            const cmd1 = {
                "Code": 0x06,
                "Address": address,
                "Request": str,
            };
            const cmd2 = {
                SerialNumber: SN,
                Setting: {
                    [address.toString(16)]: str,
                },
            }
            postCmd(cmd1, cmd2);
        }
    }

    const handleDo = async (RegisterAddressNumber) => {
        console.log("[RegisterAddressNumber]", RegisterAddressNumber.toString(16));
        const address = parseInt(RegisterAddressNumber);
        const cmd1 = {
            "Code": 0x06,
            "Address": address,
            "Request": "",
        };
        const cmd2 = {
            SerialNumber: SN,
            Setting: {
                [address.toString(16)]: 1,
            },
        }
        await postCmd(cmd1, cmd2);
    }

    const editor_onchange_handler = (props) => {
        console.log("[Setting]", props);
        var cvs = refComfirmedValues.current;
        var pvs = refPendingValues.current;
        var pvs_changed = false;
        for (var k in props) {
            var v = props[k];
            if (defMap[k].RegisterAddressNumber == 0xa03a) {
                if (v) { 
                    const year = v.year() - 2000;
                    const month = v.month()+1;
                    const day = v.date();
                    const hour = v.hour();
                    const minute = v.minute();
                    const second = v.second();
                    
                    pvs_changed = true;
                    pvs[0xa03a] = (year<<8) | month;
                    pvs[0xa03b] = (day<<8) | hour;
                    pvs[0xa03c] = (minute<<8) | second;
                }
            } else {
                if (cvs[k] == v) {
                    if (pvs.hasOwnProperty(k)) {
                        delete pvs[k];
                        pvs_changed = true;
                    }
                } else {
                    pvs[k] = v;
                    pvs_changed = true;
                }
            }
        }
        if (pvs_changed) {
            setPendingValues({...pvs});
        }
    } 

    const showItems = [
        'A028', 'A029', 'A02A', 'A02Bhide', 
        'A02C', 'A02D', 'A02E', 'A02F',
        'A030', 'A031', 'A033hide', 'A034',
        'A035', 'A036hide', 'A037', 'A03A',
        'A03F', 'A040hide', 'A041hide', 'A042',
        'A043', 'A047', 'A088', 'A08Chide', 'A08D', 'A08E',
        'A090', 'A091', 'A092', 'A093',
        'A094', 'A095', 'A096', 'A097',
        'A098', 'A099hide', 'A09A', 'A09B',
        'A09C', 'A09D', 'A09E', 'A09F',
        'A0A0', 'A0A1', 'A0A2', 'A0A3',
        'A0A4', 'A0A5', 'A0A6', 'A0A7',
        'A0A8', 'A0A9', 'A0AA', 'A0AB',
        'A0AC', 'A0AD', 'A0AF'
    ];
    var elems = [];
    const toRow = (cells, rows) => {
        var cols = [];
        for (var i in cells) {
            var cell = cells[i];
            cols.push(<Col span={12}>
                {cell}
            </Col>)
        }
        rows.push(<Row>
            {cols}
        </Row>); 
    }
    if (SettingDefs == null) {
        elems.push(t("waiting..."));
    } else {
        for (var i in defs) {
            subDefs = defs[i];
            var rows = [];
            var cells = []; 
            var showCollapse = false;
            for (var j in subDefs) {
                def = subDefs[j];

                //非admin账户只显示指定项
                if(session != null && session.IsAdmin != 1 && !showItems.includes(def['RegisterAddress'])) {
                    continue
                }

                showCollapse = true;

                if (cells.length >= 1) {
                    toRow(cells, rows);
                    cells = [];
                }
                
                var editor = null;
                if (def.ReadWrite == "W" && def.Ranges && def.Ranges.length == 3) {
                    var doing = doingsResult[def.RegisterAddressNumber];
                    editor = <Button 
                        type="primary" 
                        size="medium"
                        shape="round"
                        style={{
                            backgroundColor: "#40a9ff",
                            color: "white",
                            textTransform: "none"

                        }}
                        data-register-address={def.RegisterAddressNumber} 
                        onClick={(e) => {handleDo(e.currentTarget.getAttribute("data-register-address")); e.stopPropagation()}}
                    >{t("Do")}{doing ? (doing=="OK"?<span style={{color:"#C1FFC1"}}>&nbsp;√</span>:<span style={{color:"#FF6461"}}>&nbsp;×</span>) : ""}</Button>;
                } else {
                    if (def.RegisterAddressNumber == 0xa03a) {
                        if (pendingValues.hasOwnProperty(def.RegisterAddressNumber)) {
                            editor = <DatePicker 
                                showTime 
                                allowClear={false}
                                placeholder={t('Select datetime')}
                                suffixIcon={<EditOutlined />}
                            />
                        } else {
                            editor = <DatePicker 
                                showTime 
                                allowClear={false}
                                placeholder={t('Select datetime')}
                            />
                        }
                    } else if (def.Enums) {
                        if (def.Enums[0] == "{") {
                            var Enums = JSON.parse(def.Enums);
                            editor = (<BitsEditor key="BitEditor" BitsDef={Enums} pendingValue={pendingValues[def.RegisterAddressNumber]}></BitsEditor>);
                        } else if (def.Enums[0] == "[") {
                            //
                        } else {
                            var Enums = def.Enums.split(";");
                            var opts = [];
                            for (var k in Enums) {
                                var vn = Enums[k].split(":");
                                let kk = def.Remark.substring(6)+":"+vn[1].trim()+"-"+lang;
                                opts.push(<Select.Option
                                    key={vn[0]}
                                    value={parseInt(vn[0])}
                                    disabled={def.RegisterAddressNumber==0xa034 && (parseInt(vn[0])==0||parseInt(vn[0])==4)}
                                >{def.Intls2[kk] ?? t(vn[1])}</Select.Option>);
                            }
                            editor = <Select
                                disabled={def.ReadWrite == "R" ? true : false}
                                suffixIcon={pendingValues.hasOwnProperty(def.RegisterAddressNumber) ? <EditOutlined /> : undefined}
                            >{opts}</Select>;
                        }
                    } else if (HMAddresses.indexOf(def.RegisterAddressNumber) > -1) {
                        editor = <HourMinuteEditorForSungery 
                            key={def.RegisterAddressNumber}
                            pendingValue={pendingValues[def.RegisterAddressNumber]}
                        />;
                    } else {
                        editor = <Input  
                            disabled={def.ReadWrite == "R" ? true : false}
                            suffix={pendingValues.hasOwnProperty(def.RegisterAddressNumber) ? <EditOutlined /> : <span />}
                            placeholder={def["Ranges"] ?? ""}
                            name={def.RegisterAddressNumber}
                            id={def.RegisterAddressNumber}
                            // precision={def.Scale ? def.Scale.toString().length-2 : undefined} 
                        />;
                    }
                }
                cells.push(<div style={{display:"flex"}}>
                    <Form.Item
                        style={{width: "60%"}}
                        key={def.RegisterAddress}
                        label={def.RegisterAddressNumber==0xa03a ? t("Date Time") : (t(def.Intls[lang])+(def.Unit?` (${def.Unit})`:t("")))}
                        name={def.RegisterAddressNumber}
                        hidden={[0xa03b,0xa03c].indexOf(def.RegisterAddressNumber)>-1 ? true : false}
                        rules={def.RegisterAddressNumber==0xa03f ? [{
                            validator: (_, value) => {
                                const v = parseInt(value);
                                if (isNaN(value) || v < 0 || v > 2400) {
                                    return Promise.reject(t('Value must be between 0 and 2400'));
                                } else {
                                    return Promise.resolve();
                                }
                            }
                        }] : null}
                    >
                        {editor}
                    </Form.Item>
                    {[0xa03b,0xa03c].indexOf(def.RegisterAddressNumber)>-1 || def.ReadWrite.indexOf("R") == -1 ? "" : <><div style={{width: 8}}></div><Button 
                        type="primary" 
                        size="small"
                        shape="round"
                        style={{
                            backgroundColor: "#40a9ff",
                            color: "white",
                            textTransform: "none",
                            border: "1px solid #eee"

                        }}
                        data-registeraddressnumber={def.RegisterAddressNumber} 
                        onClick={(e) => {handleReadSingle(e.currentTarget.getAttribute("data-registeraddressnumber")); e.stopPropagation()}}
                    >{t("Read")}</Button></>}
                    {[0xa03b,0xa03c].indexOf(def.RegisterAddressNumber)>-1 || def.ReadWrite.indexOf("W") == -1 ? "" : <><div style={{width: 8}}></div><Button 
                        type="primary" 
                        size="small"
                        shape="round"
                        style={{
                            backgroundColor: "#40a9ff",
                            color: "white",
                            textTransform: "none",
                            border: "1px solid #eee"

                        }}
                        data-registeraddressnumber={def.RegisterAddressNumber} 
                        onClick={(e) => {handleWriteSingle(e.currentTarget.getAttribute("data-registeraddressnumber")); e.stopPropagation()}}
                    >{t("Write")}</Button><div style={{width: 5}}></div></>}
                </div>);
            }
            if (cells.length > 0) {
                toRow(cells, rows);
            }
            showCollapse && elems.push(<Collapse.Panel
                key={i}
                header={<span style={{fontWeight: "bold"}}>{t(subDefs[0].Category)}</span>}
                extra={subDefs[0].Category == "Setting-Instruction" ? "" : (<div key={i} style={{display:"flex"}}>
                    <Button 
                        type="primary" 
                        size="medium"
                        shape="round"
                        style={{
                            backgroundColor: "white",
                            color: "#888",
                            textTransform: "none",
                            border: "1px solid #eee"

                        }}
                        data-category={subDefs[0].Category} 
                        onClick={(e) => {handleReset(e.currentTarget.getAttribute("data-category")); e.stopPropagation()}}
                    >{t("Reset")}</Button>
                    <div style={{ width: "30px" }}></div>
                    <Button 
                        type="primary" 
                        size="medium"
                        shape="round"
                        style={{
                            backgroundColor: "#40a9ff",
                            color: "white",
                            textTransform: "none"

                        }}
                        data-category={subDefs[0].Category} 
                        onClick={(e) => {handleRead(e.currentTarget.getAttribute("data-category")); e.stopPropagation()}}
                    >{t("Read")}</Button>
                    <div style={{ width: "15px" }}></div>
                    <Button 
                        type="primary" 
                        size="medium"
                        shape="round"
                        style={{
                            backgroundColor: "#40a9ff",
                            color: "white",
                            textTransform: "none"

                        }} 
                        data-category={subDefs[0].Category} 
                        onClick={(e) => {handleWrite(e.currentTarget.getAttribute("data-category")); e.stopPropagation()}}
                    >{t("Write")}</Button>
                </div>)}
            >
                {rows}
            </Collapse.Panel>);
        }
    }
    

    return (
        <div
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
            }}
        >{SettingDefs==null ? t("waiting...") : (<>
            <div style={{
                flex: '1 1 auto',
                backgroundColor: 'white',
                overflowY: "scroll"
            }}>
                <Form
                    form={form}
                    labelCol={{ span: 12 }}
                    wrapperCol={{ span: 8 }}
                    layout="horizontal"
                    size="small"
                    style={{
                        width: "100%",
                    }}
                    onValuesChange={editor_onchange_handler}
                >
                    <Collapse defaultActiveKey={['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19']}>{elems}</Collapse>
                </Form>
            </div>
            <WS
                SerialNumber={SN}
                onConnect={handleWSConnect}
                onData={handleWSData}
                onClose={handleWSClose}
                onError={handleWSError}
            ></WS>
        </>)}
        </div>
    );
}

export default SungerySetting;